import React from "react";
//#region components
import { Divider, Grid, Skeleton } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const TitledContainerSkeleton: React.FC = (props) => {
  return (
    <Grid container direction="column" gap={2}>
      <Grid item container className={cssExports.topSection}>
        <Grid container spacing={1.5}>
          <Grid item xs={12}>
            <Skeleton width="50%" height="24px" />
          </Grid>
          <Grid item xs={12}>
            <Skeleton width="40%" height="8px" />
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Divider className={cssExports.dividerGray} />
      </Grid>
      <Grid item container className={cssExports.midSection}>
        <Grid container rowGap={0.5} direction="column">
          {[...Array(3)].map((val, index) => (
            <Grid key={index} item container>
              <Skeleton width="33%" height="8px" />
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid item container className={cssExports.bottomSection}>
        <Grid container direction="row" spacing={1} wrap="nowrap">
          <Grid item>
            <Skeleton width="8px" height="8px" />
          </Grid>
          <Grid item xs>
            <Skeleton width="33%" height="8px" />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TitledContainerSkeleton;
